import $ from 'jquery';

$('.logo-collection--slider .logo-collection__items').slick({
    autoplay: false,
    autoplaySpeed: 7000,
    fade: false,
    infinite: true,
    arrows: true,
    dots: false,
    draggable: true,
    mobileFirst: true,
    prevArrow: '<i class="slick-prev fal fa-chevron-left"></i>',
    nextArrow: '<i class="slick-next fal fa-chevron-right"></i>',
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1023,
            settings: {
                draggable: false,
                slidesToShow: 4,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint: 1279,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 2,
            },
        }
    ]
});
